import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";

const IMAGES = [
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1517502884422-41eaead166d4?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1531973576160-7125cd663d86?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1505409859467-3a796fd5798e?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1469981283837-561b3779462f?auto=format&fit=crop&w=1400&q=80",
];

// Asymmetric bento layout — 11 cells
const SPANS = [
  "md:col-span-3 md:row-span-2",
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-2 md:row-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
];

export default function ApplicationsSection() {
  const { t } = useI18n();
  const items = t("applications.items");

  return (
    <section
      data-testid={TID.applications}
      className="relative bg-[color:var(--gc-paper)] py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <p className="gc-eyebrow">{t("applications.eyebrow")}</p>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-[700] text-[color:var(--gc-ink)]">
              {t("applications.title")}
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-lg leading-relaxed text-[color:var(--gc-graphite)]">
              {t("applications.lead")}
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-6 auto-rows-[140px] md:auto-rows-[180px] gap-3">
          {Array.isArray(items) &&
            items.map((it, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: (i % 6) * 0.04 }}
                className={`relative overflow-hidden group cursor-default ${SPANS[i] || "md:col-span-2"}`}
              >
                <img
                  src={IMAGES[i % IMAGES.length]}
                  alt=""
                  className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-110 transition-all duration-[900ms]"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--gc-navy)]/85 via-[color:var(--gc-navy)]/15 to-transparent" />
                <div className="absolute inset-0 p-4 md:p-5 flex flex-col justify-between">
                  <span className="font-mono text-[10px] tracking-[0.2em] text-white/70 self-start">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex items-end justify-between gap-2">
                    <h3 className="text-white font-display font-[700] text-base md:text-lg leading-tight tracking-tight">
                      {it}
                    </h3>
                    <span className="w-2 h-2 bg-[color:var(--gc-red)] shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                </div>
              </motion.div>
            ))}
        </div>
      </div>
    </section>
  );
}
